import moment from "moment";
import React from "react";

import { useLocalStorage } from "../../../hooks";
import { userState } from "../../../redux/reducers/userReducer";

import profile_img from "../../../assets/avatar_placeholder.png";

import { FunnelIcon } from "@heroicons/react/20/solid";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { TwButton, TwListBox } from "../../../components/tailwind";
import { classNames, cutString } from "../../../helpers";
import { loadingState } from "../../../redux/reducers/loadingReducer";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForBookings } from "../../../utils/confighelpers";
import { bookingStatusFilter, profileDefaultAvatar } from "../../../utils/constants";
import SessionBookingPopover from "./SessionBookingPopover";
import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";


export default function RecentEventBooking({
    title = "Recent Bookings",
    bookingType = "teacherRecentBookings",
    customerId,
}) {
    const { t, i18n } = useTranslation();
    title = t("bookings.recentBookingTitle")
    const location = useLocation();
    const dispatch = useDispatch();
    const loadingReduxState = useSelector(loadingState);
    const [userToken] = useLocalStorage("userToken");
    const userReduxState = useSelector(userState);
    const [bookingInfo, setBookingInfo] = React.useState();
    // const [anchorEl, setAnchorEl] = React.useState(null);
    const [listLoading, setListLoading] = React.useState(false);

    const [recentBookingsList, setRecentBookingsList] = React.useState([]);
    const [showViewMore, setShowViewMore] = React.useState(false);
    const [recentBookingsPageNumber, setRecentBookingsPageNumber] = React.useState(1);
    const [bookingFilter, setBookingFilter] = React.useState('all');

    const getRecentBookings = async (page = 1) => {
        setShowViewMore(false);
        setListLoading(true);
        const manageClassesConfig = {
            method: "get",
            // url: `${getUrlForBookings()}getMybookings?teacherId=${userReduxState.userData?._id}${bookingType === "consumerBookings" ? `&studentId=${customerId}` : ``}&page=${page}&limit=5&filterBy=${bookingFilter}&listFor=${userReduxState.businessType}`,
            url: `${getUrlForBookings()}getMybookings?organizerId=${userReduxState.userData?._id}&teacherId=${userReduxState.userData?._id}&page=${page}&limit=5&filterBy=${bookingFilter}&listFor=${userReduxState.businessType}`,

        };
        const manageClassesRequest = await axiosInstance(manageClassesConfig);
        if (manageClassesRequest.status === 200) {
            if (manageClassesRequest.data.data.data.length) {
                setShowViewMore(true);
                if (recentBookingsPageNumber > 1) {
                    setRecentBookingsList([...recentBookingsList, ...manageClassesRequest.data.data.data]);
                } else {
                    setRecentBookingsList(manageClassesRequest.data.data.data);
                }
            }
        }
        setListLoading(false);
    };

    const handleFilterChange = (event) => {
        const { target: { value } } = event;
        setRecentBookingsPageNumber(1)
        setBookingFilter(value);
        setRecentBookingsList([])
    };

    const calculateBoughtTickets = (row) => {
        let totalBookedTickets = 0;

        if (row && row?.ticketsBought?.length) {
            row?.ticketsBought.forEach((item) => {
                totalBookedTickets = totalBookedTickets + parseInt(item.bookingQty)
            })
        }

        return totalBookedTickets
    }

    const ticketPrice = (row) => {
        let amountPaid = "";

        if (row && row?.paymentMethod === "classPass" && row?.passVoucherCode) {
            amountPaid = `${calculateBoughtTickets(row)} Credit`
        } else if (row && row?.ticketsBought?.length) {
            // row?.ticketsBought.forEach((item) => {
            //     // amountPaid = `€${parseFloat(parseFloat(item?.ticketPrice ? item?.ticketPrice : 0)).toFixed(2)} `
            // })
            amountPaid = `€${parseFloat(row?.totalPriceToConsumer || 0).toFixed(2)} `
        }

        return amountPaid
    }

    const getPaymentStatus = (row) => {
        let paymentStatus = row.paymentStatus;
        if (row && row.paymentStatus.toLowerCase() === "paid") {
            paymentStatus = `Paid Online`
        }

        return paymentStatus
    }

    React.useEffect(() => {
        getRecentBookings(recentBookingsPageNumber);
    }, [recentBookingsPageNumber, bookingFilter]);

    return (
        <div
            className={`max-w-7xl bg-white rounded-lg border-2 border-bright-gray hover:border-primary ${bookingType === "teacherRecentBookings" ? "min-h-[500px] pb-10" : ""}`}
        >
            <div className={"flex flex-row justify-between items-center border-b-2 border-bright-gray p-5"}>
                <div className={"flex flex-col"} style={{ flex: 1 }}>
                    <div className="flex justify-between">
                        <h3 className={"text-black text-lg font-bold"} >
                            {title}
                        </h3>
                        <div className="flex gap-2 justify-end items-center">
                            <TwButton variant={"default"} onClick={() => {
                                setRecentBookingsPageNumber(1);
                            }}>
                                <ArrowPathIcon aria-hidden="true" className="size-5 text-black forced-colors:text-[Highlight]" />
                            </TwButton>
                            <TwListBox
                                value={bookingFilter}
                                options={bookingStatusFilter}
                                dropdownArrow={(<FunnelIcon aria-hidden="true" className="size-5 text-black forced-colors:text-[Highlight]" />)}
                                onChange={(v) => {
                                    handleFilterChange({ target: { value: v.value } })
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="overflow-x-auto my-5 sm:m-5">
                <div className="inline-block min-w-full py-2 align-middle sm:px-1 overflow-x-auto">
                    <div className="overflow-hidden [shadow] ring-0 ring-black/5 sm:rounded-lg">
                        <table className="min-w-full divide-y divide-gray-300">
                            <thead className="bg-form">
                                <tr>
                                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                        {t("dashboard.customer")}
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        {t("bookings.bookingId")}
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        {t("dashboard.activityBooked")}
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        {t("bookings.seatsBooked")}
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        {t("bookings.amountPaid")}
                                    </th>
                                    <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                        <span className="sr-only">{t("account.tableActionHead")}</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 bg-white">
                                {listLoading ? (
                                    <tr>
                                        <td colSpan={6} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center">
                                            {t("inputFieldsTitle.loading")}
                                        </td>
                                    </tr>
                                ) : (recentBookingsList.length > 0 ? recentBookingsList.map((row, i) => (
                                    <tr key={i}>
                                        <td className="whitespace-nowrap py-5 pt-6 pl-4 pr-3 text-sm font-bold text-gray-900 sm:pl-6 flex gap-2 items-center flex ">
                                            <div className="flex justify-start items-center [min-w-4/5] w-full line-clamp-1">
                                                <div className="flex-none">
                                                    {row?.consumer_detail?.profilePic ? (<img
                                                        className="size-8 rounded-full mr-3"
                                                        src={row?.consumer_detail?.profilePic ?? profileDefaultAvatar}
                                                        alt={``}
                                                    />) : (<img
                                                        className="size-8 rounded-full mr-3"
                                                        src={profile_img}
                                                        // src={profileDefaultAvatar}
                                                        alt={``}
                                                    />)}
                                                </div>
                                                <div className="flex-1 min-w-0 line-clamp-1">
                                                    {/* <div>{cutString(row?.studentName, 10, true)}</div> */}
                                                    <div className=" line-clamp-1">{row?.consumer_detail?.fullName}</div>
                                                    <div className="text-primary line-clamp-1">{(row.consumer_detail?.countryCode ? row.consumer_detail.countryCode + "_" + row.consumer_detail.phoneNumber : "" + row?.consumer_detail?.username)}</div>
                                                    {/* <div className=" line-clamp-1">{row?.consumerFullname}</div>
                                                    <div className="text-primary line-clamp-1">{(row.consumerUsername)}</div> */}
                                                </div>
                                            </div>
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold"><div>{row.bookingId}<p className="text-xs text-gray-400 font-normal text-wrap"><span className={`${(row.status === "Cancelled") ? "text-bz-status-red" : "text-bz-status-green"}`}>{row.status}</span> | {moment(row.bookingDate).format("MMM D")}</p></div></td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold"><div>{row?.eventName || row?.event_schedule_detail?.eventName || ""}<p className="text-xs text-gray-400 font-normal text-wrap">{row.event_schedule_detail && row.event_schedule_detail.eventDate ? moment(row.event_schedule_detail.eventDate).format('MMM D, hh:mm A') : ""}</p></div></td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold"><div>
                                            {row.bookingQty ? row.bookingQty : "1"}
                                            <p className="text-xs text-gray-400 font-normal text-wrap" title={row?.ticketsBought ? row.ticketsBought.map((ticket, i) => {
                                                return ticket.bookingQty + " x " + ticket.ticketType + " "
                                            }).join(" | ") : ""}>
                                                {cutString(row?.ticketsBought ? row.ticketsBought.map((ticket, i) => {
                                                    return ticket.bookingQty + " x " + ticket.ticketType + " "
                                                }).join(" | ") : "", 25, true)}
                                            </p>
                                        </div></td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold">
                                            <div>
                                                {ticketPrice(row)}
                                                <p className="text-xs text-gray-400 font-normal text-wrap capitalize">{getPaymentStatus(row)}</p>
                                            </div>
                                        </td>
                                        <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                            <SessionBookingPopover
                                                bookingDetails={row}
                                                handleUpdate={() => {
                                                    getRecentBookings()
                                                }}
                                            />
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan={6} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center">
                                            {t("bookings.noBookingsYet")}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {false && (<div className="overflow-x-auto m-5">
                <table className="min-w-full divide-y divide-gray-300">
                    <thead className="">
                        <tr className="text-center">
                            <th scope="col" className={classNames("py-3.5 pl-4 pr-3 text-center text-base font-extrabold text-gray-900 sm:pl-6 truncate", bookingType === "consumerBookings" ? "hidden" : "")}>
                                {t("dashboard.customer")}
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-base font-extrabold text-gray-900 truncate">
                                {t("bookings.bookingId")}
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-base font-extrabold text-gray-900 truncate">
                                {t("dashboard.activityBooked")}
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-base font-extrabold text-gray-900 truncate">
                                {t("bookings.seatsBooked")}
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-base font-extrabold text-gray-900 truncate">
                                {t("bookings.amountPaid")}
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-center text-base font-extrabold text-gray-900"></th>
                        </tr>
                    </thead>
                    <tbody className="divide-y-8 !border-y-0 divide-white ">
                        {listLoading ? (
                            <tr>
                                <td colSpan={6} className="bg-td-row hover:bg-td-row-h whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center rounded-2xl">
                                    {t("inputFieldsTitle.loading")}
                                </td>
                            </tr>
                        ) : recentBookingsList.length ? recentBookingsList.map((row, i) => (
                            <tr key={i} className="bz-td-row">
                                <td className={classNames("bg-white whitespace-nowrap px-3 py-4 text-left text-sm font-bold rounded-l-2xl", bookingType === "consumerBookings" ? "hidden" : "")}>
                                    <div className="flex justify-center items-center min-w-4/5">
                                        <div className="flex-none">
                                            {row?.consumer_detail?.profilePic ? (<img
                                                className="size-8 rounded-full mr-3"
                                                src={row.consumer_detail.profilePic}
                                                alt={``}
                                            />) : (<img
                                                className="size-8 rounded-full mr-3"
                                                src={profile_img}
                                                alt={``}
                                            />)}
                                        </div>
                                        <div className="w-28">
                                            {/* <div>{cutString(row?.studentName, 10, true)}</div> */}
                                            <div>{cutString(row?.consumer_detail?.fullName, 10, true)}</div>
                                            <div className="text-indigo-bz">{cutString((row.consumer_detail?.countryCode ? row.consumer_detail.countryCode + "_" + row.consumer_detail.phoneNumber : "" + row?.consumer_detail?.username), 10, true)}</div>
                                        </div>
                                    </div>
                                </td>
                                <td className={classNames("bg-white whitespace-nowrap px-3 py-4 text-left text-sm font-bold", bookingType === "consumerBookings" ? "rounded-l-2xl" : "")}>
                                    {row.bookingId}
                                    <p className="text-xs text-gray-400 font-normal text-wrap"><span className={`${(row.status === "Cancelled") ? "text-bz-status-red" : "text-bz-status-green"}`}>{row.status}</span> | {moment(row.bookingDate).format("MMM D")}</p>
                                </td>
                                <td className="bg-white whitespace-nowrap px-3 py-4 text-left text-sm font-bold">
                                    {row?.eventName || row?.event_schedule_detail?.eventName || ""}
                                    <p className="text-xs text-gray-400 font-normal text-wrap">{row.event_schedule_detail && row.event_schedule_detail.eventDate ? moment(row.event_schedule_detail.eventDate).format('MMM D, hh:mm A') : ""}</p>
                                </td>
                                <td className="bg-white whitespace-nowrap px-3 py-4 text-left text-sm font-bold">
                                    {row.bookingQty ? row.bookingQty : "1"}
                                    <p className="text-xs text-gray-400 font-normal text-wrap" title={row?.ticketsBought ? row.ticketsBought.map((ticket, i) => {
                                        return ticket.bookingQty + " x " + ticket.ticketType + " "
                                    }).join(" | ") : ""}>
                                        {cutString(row?.ticketsBought ? row.ticketsBought.map((ticket, i) => {
                                            return ticket.bookingQty + " x " + ticket.ticketType + " "
                                        }).join(" | ") : "", 25, true)}
                                    </p>
                                </td>
                                <td className="bg-white whitespace-nowrap px-3 py-4 text-left text-sm font-bold">
                                    {ticketPrice(row)}
                                    <p className="text-xs text-gray-400 font-normal text-wrap">{getPaymentStatus(row)}</p>
                                </td>
                                <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-sm font-bold rounded-r-2xl">
                                    <SessionBookingPopover
                                        bookingDetails={row}
                                        handleUpdate={() => {
                                            getRecentBookings()
                                        }}
                                    />
                                </td>
                            </tr>
                        )) : (
                            <tr>
                                <td colSpan={6} className="bg-td-row hover:bg-td-row-h whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center rounded-2xl">
                                    {/* There is no {bookingFilter !== "all" ? bookingFilter + " " : ""}bookings */}
                                    {t("bookings.noBookingsYet")}
                                </td>
                            </tr>
                        )}

                    </tbody>
                </table>
            </div>)}
            {showViewMore ? (<div className={"flex flex-row justify-center my-4"}>
                <TwButton
                    variant={"default-box"}
                    className="sm:min-w-32 truncate !text-primary"
                    onClick={() => {
                        setRecentBookingsPageNumber(recentBookingsPageNumber + 1);
                    }}
                >
                    {t("inputFieldsTitle.viewMore")}
                </TwButton>
            </div>) : ""}
        </div>
    );
}
